// Lucide-style action icons; inherit the button color.
const paths: Record<string, string> = {
  'action.cancel': 'm18 6-12 12 M6 6l12 12',
  'action.copy': 'M9 9h12v12H9z M5 15H3V3h12v2',
  'action.download': 'M21 15v6H3v-6 M12 3v12 m-5-5 5 5 5-5',
  'action.save': 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12l4 4v12a2 2 0 0 1-2 2 M7 3v6h10 M7 21v-8h10v8',
  'action.save_password': 'M5 11h14v10H5z M8 11V7a4 4 0 0 1 8 0v4 M12 15v2',
  'action.authorize': 'M12 3 3 7v5c0 5 9 9 9 9s9-4 9-9V7z m-4 9 3 3 5-5',
  'action.sign_in': 'M9 3h10v18H9 M3 12h12 m-4-4 4 4-4 4',
  'action.create_account': 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M20 8v6 M17 11h6',
};

const ActionIcon = ({ title }: { readonly title: string }) => (
  <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={paths[title] ?? 'M5 12h14 m-6-6 6 6-6 6'} />
  </svg>
);

export default ActionIcon;
